import { readCmmdForgeRuntimeListSnapshot } from "../cmmd/cmmdForgeRuntimeListResource";
import { getCurrentForgeWorkspaceId } from "../workspace/currentForgeWorkspaceStore";
import {
  deriveCatalogView,
  type FirstRunCatalogSource,
} from "../components/onboarding/useFirstRunEnvironment.logic";

export const MISSING_FORGE_CLOUD_SERVER_ERROR_CODE = "missing_forge_cloud_server" as const;

export const MISSING_FORGE_CLOUD_SERVER_MESSAGE =
  "No Forge cloud server yet. Finish Setup to create one, then try again.";

export const TASK_WORK_MISSING_FORGE_CLOUD_SERVER_MESSAGE =
  "This task needs a Forge cloud server before it can start. Finish Setup to create one.";

export type MissingForgeCloudServerState = "unknown" | "missing" | "present";

/**
 * Whether this Seat has a durable Environment row in CMMD yet.
 *
 * Only a settled catalog read counts as "missing": treating the pre-fetch
 * snapshot as empty is how ensure used to fire before Environments loaded
 * (forge#3572).
 */
export function resolveMissingForgeCloudServerState(
  catalog: FirstRunCatalogSource,
  currentWorkspaceId: number | null,
): MissingForgeCloudServerState {
  const view = deriveCatalogView(catalog, currentWorkspaceId);
  if (!view.settled) return "unknown";
  return view.environmentId === null ? "missing" : "present";
}

function readMissingForgeCloudServerState(): MissingForgeCloudServerState {
  return resolveMissingForgeCloudServerState(
    readCmmdForgeRuntimeListSnapshot(),
    getCurrentForgeWorkspaceId(),
  );
}

function createMissingForgeCloudServerError(): Error {
  return Object.assign(new Error(MISSING_FORGE_CLOUD_SERVER_MESSAGE), {
    code: MISSING_FORGE_CLOUD_SERVER_ERROR_CODE,
  });
}

/**
 * Blocks implicit `/ensure` from thread/task flows when the Seat has no
 * Environment yet. Seat provisioning stays on `/setup` via `ensureSeatEnvironment`.
 */
export function assertForgeCloudServerPresentForConnect(): void {
  if (readMissingForgeCloudServerState() === "missing") {
    throw createMissingForgeCloudServerError();
  }
}
